"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MsgVoteWeighted = void 0;
var json_1 = require("../../../util/json");
/**
 * Weighted vote for a proposal
 */
var MsgVoteWeighted = /** @class */ (function (_super) {
    __extends(MsgVoteWeighted, _super);
    /**
     * @param proposal_id ID of proposal to vote on
     * @param voter voter's account address
     * @param option one of voting options
     */
    function MsgVoteWeighted(proposal_id, voter, options) {
        var _this = _super.call(this) || this;
        _this.proposal_id = proposal_id;
        _this.voter = voter;
        _this.options = options;
        return _this;
    }
    MsgVoteWeighted.fromData = function (data) {
        var _a = data.value, proposal_id = _a.proposal_id, voter = _a.voter, options = _a.options;
        return new MsgVoteWeighted(Number.parseInt(proposal_id), voter, options);
    };
    MsgVoteWeighted.prototype.toData = function () {
        var _a = this, proposal_id = _a.proposal_id, voter = _a.voter, options = _a.options;
        return {
            type: 'gov/MsgVoteWeighted',
            value: {
                proposal_id: proposal_id.toFixed(),
                voter: voter,
                options: options,
            },
        };
    };
    return MsgVoteWeighted;
}(json_1.JSONSerializable));
exports.MsgVoteWeighted = MsgVoteWeighted;
//# sourceMappingURL=MsgVoteWeighted.js.map